
(function () {
  'use strict';

  var COUNTRY_TO_LANG = {
    DE:'de', FR:'fr', DK:'da', SE:'en', NO:'en', PL:'en', GB:'en', CH:'de',
    AT:'de', BE:'fr', LU:'fr', IT:'it', ES:'es', IE:'en'
    /* SE -> sv, NO -> no, PL -> pl once those languages exist as Shopify locales. */
  };

  /* The languages this site can serve, rendered by Liquid from Shopify's own
     published locales, each already carrying its correct root_url prefix.
     History, so nobody re-derives it: until 2026-09-09 this list was a UNION of
     Shopify's locales and Weglot's, because Danish moved to Shopify first while
     German and French were still on Weglot. Weglot is uninstalled and its half of
     the union always returned an empty list, so the union was removed and this is
     now Shopify's list alone. Behaviour is unchanged. */
  var INT_SHOP_LANGS = JSON.parse(document.getElementById('int-hdr-lang-data').textContent);

  var INT_ORIGIN = 'en';
  for (var _i = 0; _i < INT_SHOP_LANGS.length; _i++) {
    if (INT_SHOP_LANGS[_i].primary) INT_ORIGIN = INT_SHOP_LANGS[_i].iso;
  }

  /* Every language the site can actually serve right now. */
  function availableLangs() {
    var out = [];
    INT_SHOP_LANGS.forEach(function (l) { if (out.indexOf(l.iso) === -1) out.push(l.iso); });
    if (out.indexOf(INT_ORIGIN) === -1) out.push(INT_ORIGIN);
    return out;
  }
  window.__intAvailableLangs = availableLangs;

  /* The prefix a language is served under, from Shopify's root_url ("/da").
     The origin language has no prefix. */
  function langPrefix(lang) {
    if (lang === INT_ORIGIN) return '';
    for (var i = 0; i < INT_SHOP_LANGS.length; i++) {
      if (INT_SHOP_LANGS[i].iso === lang) {
        var r = INT_SHOP_LANGS[i].root || '';
        return r === '/' ? '' : r.replace(/\/$/, '');
      }
    }
    return '/' + lang;
  }

  /* The language is read off the URL. Anything without a known prefix is the
     origin language. */
  function currentLang() {
    var seg = (window.location.pathname || '/').split('/');
    if (seg[1] && availableLangs().indexOf(seg[1]) !== -1) return seg[1];
    return INT_ORIGIN;
  }
  window.__intCurrentLang = currentLang;

  function langForCountry(code) {
    var lang = COUNTRY_TO_LANG[(code || '').toUpperCase()] || INT_ORIGIN;
    if (lang !== INT_ORIGIN && availableLangs().indexOf(lang) === -1) lang = INT_ORIGIN;
    return lang;
  }
  window.__intLangForCountry = langForCountry;

  function closeAll() {
    document.querySelectorAll('.header__weglot.is-open').forEach(function (c) {
      c.classList.remove('is-open');
      var t = c.querySelector('.header__weglot-trigger');
      var d = c.querySelector('.header__weglot-dropdown');
      if (t) t.setAttribute('aria-expanded', 'false');
      if (d) d.setAttribute('aria-hidden', 'true');
    });
  }
  var _openTs = 0;
  function open(container, trigger) {
    closeAll();
    container.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
    var d = container.querySelector('.header__weglot-dropdown');
    if (d) d.setAttribute('aria-hidden', 'false');
    _openTs = Date.now();
  }
  function bindTriggers() {
    document.querySelectorAll('.header__weglot-trigger').forEach(function (trigger) {
      if (trigger.__intRegionBound) return;
      trigger.__intRegionBound = true;
      var container = trigger.closest('.header__weglot');
      if (!container) return;
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (container.classList.contains('is-open')) closeAll();
        else open(container, trigger);
      }, true);
    });
  }
  document.addEventListener('click', function (e) {
    if (Date.now() - _openTs < 300) return;
    if (!e.target.closest('.header__weglot')) closeAll();
  }, false);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  var submitting = false;
  function submitRegion(select) {
  if (submitting) return;
  submitting = true;

  var form = select.closest('form');
  if (!form) { submitting = false; return; }

  var field = select.closest('.int-region__field');
  if (field) field.classList.add('is-switching');

  var country = (select.value || '').toUpperCase();
  var lang    = langForCountry(country);
  var origin  = INT_ORIGIN;
  var nowLang = currentLang();

  try { sessionStorage.setItem('int_currency_override', '1'); } catch (e) {}

  if (!form.querySelector('[name="authenticity_token"]')) {
    var tok = document.querySelector('meta[name="csrf-token"]');
    if (tok) {
      var h = document.createElement('input');
      h.type = 'hidden'; h.name = 'authenticity_token';
      h.value = tok.getAttribute('content');
      form.appendChild(h);
    }
  }

  /* Build the target path for the chosen language, stripping any language
     prefix already on the current path. */
  function langPath(target) {
    var path = window.location.pathname || '/';
    var avail = availableLangs();
    var seg = path.split('/');
    if (seg[1] && avail.indexOf(seg[1]) !== -1) { seg.splice(1, 1); path = seg.join('/') || '/'; }
    var prefix = langPrefix(target);
    if (!prefix) return path + window.location.search;
    return prefix + (path === '/' ? '' : path) + window.location.search;
  }

  /* Set the market/currency cookie, then make the language the single final
     navigation. A full nav to /<lang><path> renders the language and the new
     currency via the cookie, so the two cannot race. */
  var body = new URLSearchParams(new FormData(form)).toString();
  fetch(form.action, {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
    body: body
  }).then(function () {
    if (lang !== nowLang) window.location.assign(langPath(lang));
    else window.location.reload();
  }).catch(function () { form.submit(); });
}

  function bindSelects() {
    document.querySelectorAll('[data-int-region-select]').forEach(function (select) {
      if (select.__intRegionBound) return;
      select.__intRegionBound = true;
      select.addEventListener('change', function () { submitRegion(select); });
      var form = select.closest('form');
      if (form) form.addEventListener('submit', function (e) { e.preventDefault(); submitRegion(select); });
    });
  }

  function init() { bindTriggers(); bindSelects(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
